var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c("base-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isRefreshing,
            expression: "isRefreshing",
          },
        ],
        ref: "baseTable",
        attrs: {
          "base-url": _vm.urlWithFilters,
          "element-loading-spinner": "el-icon-loading",
        },
        on: {
          "load-success": _vm.onLoadSuccess,
          "load-error": _vm.onLoadError,
          refresh: _vm.onRefresh,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "el-table",
                  {
                    staticClass: "w-100",
                    attrs: {
                      data: _vm.items,
                      stripe: "",
                      "max-height": "600",
                      "row-key": "id",
                      "row-class-name": _vm.rowClass,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: "Date",
                        "min-width": "200",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reg_msg_count",
                        label: "SMS",
                        "min-width": "90",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "unique_bulk_msg_count",
                        label: "Group SMS",
                        "min-width": "105",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "call_count",
                        label: "Calls",
                        "min-width": "90",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "call_total_duration",
                        label: "Calls Duration",
                        "min-width": "120",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reg_em_msg_count",
                        label: "Emails",
                        "min-width": "100",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "unique_bulk_em_msg_count",
                        label: "Group Emails",
                        "min-width": "115",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }